import { ReactNode } from 'react'
import styled from 'styled-components'
// pbo-core 전역 스타일. 앱 엔트리가 아니라 이 화면 청크에서만 로드해 기존 화면 영향 범위를 좁힌다
// (SETUP-pbo-core.md §3 — antd 를 쓰지 않던 레포는 화면 래퍼 스코프 적용 권장).
import '@musinsa/pbo-core/tokens.css'
import '@musinsa/pbo-core/styles.css'
import '@musinsa/pbo-core/fonts.css'
import { ConfigProvider } from '@musinsa/pbo-core'
import { pboLogisticsTheme } from '@musinsa/pbo-core/theme'

/**
 * pbo-core 화면 래퍼. 이 안에서만 antd 테마(pboLogisticsTheme)가 적용된다.
 *
 * 레포 전역(App.tsx)에 두지 않는 이유 — moms-fe 는 antd 를 쓰지 않던 레포라 전역 ConfigProvider 는
 * 기존 화면에 영향을 줄 수 있다. 핸드오프 화면이 늘어나면 그때 전역으로 올린다.
 */
export function PboScope({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider theme={pboLogisticsTheme}>
      <PageContainer>{children}</PageContainer>
    </ConfigProvider>
  )
}

/**
 * 페이지 컨테이너. 블록 사이 세로 간격 20px — 핸드오프 README "렌더 기본값" 의 캔버스 기본값이다.
 *
 * 공용 `PageLayout` 을 쓰지 않는다 — `height: 100%` 라서 pbo-core `PageHeader` 의 래퍼
 * (`.dev-page-header-wrap { height: 100%; justify-content: center }`)가 페이지 전체 높이를 차지하고
 * 제목을 세로 중앙에 띄운다. 높이를 콘텐츠에 맡겨야 데모와 같은 간격이 된다.
 */
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  /* pbo-core PageHeader 는 항상 sticky 인데(문서화된 동작) 배경이 없어 스크롤 시 본문이 제목을 뚫고 보인다.
     데모 앱 셸이 붙이던 .sticky 배경 규칙을 이 화면 범위에서 대신 준다. */
  .dev-page-header-wrap.pin {
    background: #fff;
  }

  /* pbo-core 필터 카드는 min-width: 1080px 라 창을 줄여도 줄지 않고 가로 스크롤이 생긴다.
     pbo-core 자신도 .capmaster-history-filter 에서 같은 방식으로 푼다. 필드는 flex-wrap 이라 알아서 접힌다. */
  .dev-search-container {
    min-width: 0;
  }
`
